
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function MSfabricationslide() {



  const cardData =
  {
    keyword: ' MS Fabrication Slide Door Installation',
    heading: 'Anjali Enterprises: MS Fabrication Slide Door Installation ',
    headingDescription: 'Anjali Enterprises offers expert MS (Mild Steel) fabrication sliding door installation services, providing durable, modern, and high-performance sliding doors for both residential and commercial use. Our steel sliding doors are designed to enhance the functionality and aesthetic of your space, ensuring smooth operation and robust security. Whether you are looking for industrial steel doors or custom designs, we provide tailored solutions to meet your specific needs.',

    "topPlaces": [
        {
          "title": "Steel Sliding Doors",
          "description": "Our steel sliding doors are crafted from high-quality mild steel, ensuring strength and durability. These doors are perfect for a range of applications, offering both security and style while saving space with their sliding mechanism."
        },
        {
          "title": "MS Sliding Doors for Offices",
          "description": "We specialize in the installation of MS sliding doors for offices, providing sleek, modern designs that allow for easy space management while offering superior security and durability. These doors are perfect for creating stylish office entrances or dividing internal spaces."
        },
        {
          "title": "Modern Sliding Doors in Pune",
          "description": "Anjali Enterprises offers modern sliding doors in Pune that combine contemporary design with functionality. Our sliding doors are ideal for enhancing your office or residential space with clean lines, ease of use, and excellent durability."
        },
        {
          "title": "Industrial Steel Sliding Doors",
          "description": "For industrial applications, we provide heavy-duty steel sliding doors designed to withstand high-traffic areas and harsh conditions. These doors offer robust security and are built to perform reliably for warehouses, factories, and other industrial environments."
        },
        {
          "title": "MS Door Fabricators",
          "description": "As experienced MS door fabricators, we specialize in creating custom sliding doors tailored to your specifications. Our team ensures that each door is meticulously crafted to meet your design and functionality requirements."
        },
        {
          "title": "Sliding Door Work for Residential and Commercial Use",
          "description": "Whether for homes or commercial establishments, our sliding doors are designed to blend seamlessly with the overall décor while offering practical benefits such as space-saving and easy access. We provide a wide range of sliding door solutions that suit both residential and commercial needs."
        },
        {
          "title": "Custom MS Sliding Doors",
          "description": "We offer custom MS sliding doors that are designed to meet your specific requirements in terms of size, design, and function. From modern aesthetics to industrial designs, we provide bespoke sliding doors that perfectly complement your space."
        },
        {
          "title": "Durable Sliding Doors for High-Traffic Areas",
          "description": "For areas with heavy foot traffic, we provide durable sliding doors that are built to last. Our doors are made from robust materials to ensure they withstand regular use while maintaining their performance and appearance over time."
        },
        {
          "title": "Steel Sliding Door Solutions",
          "description": "Anjali Enterprises delivers comprehensive steel sliding door solutions, from design to installation. Whether you need a sliding door for your home, office, or industrial space, we provide durable, secure, and stylish options to enhance any environment."
        },
        {
          "title": "Anjali Enterprises Contact Number",
          "description": "Contact Anjali Enterprises at +91 8793220265 for reliable and high-quality MS (Mild Steel) fabrication slide door installation services. We specialize in designing and fabricating strong, durable, and stylish MS sliding doors for both residential and commercial properties, offering enhanced security and space-saving solutions. Get in touch for expert installation and professional service. Serving Pune with top-notch MS fabrication slide door solutions tailored to your needs."
        }
      ],
      "tableData": [
        ["- Steel Sliding Doors", "- MS Sliding Doors for Offices"],
        ["- Modern Sliding Doors in Pune", "- Industrial Steel Sliding Doors"],
        ["- MS Door Fabricators", "- Sliding Door Work for Residential and Commercial Use"],
        ["- Custom MS Sliding Doors", "- Durable Sliding Doors for High-Traffic Areas"],
        ["- Steel Sliding Door Solutions", "- Anjali Enterprises Contact Number"],
        ["", ""]
      ],


   "whychoose": [
  {
    "WhyChooseheading": "Durability and Strength",
    "WhyChoosedescription": "At Anjali Enterprises, we specialize in MS (Mild Steel) fabrication slide doors that offer exceptional strength and durability. Our doors are constructed using premium-quality mild steel that ensures robust performance, even in high-traffic areas. These doors are designed to withstand wear and tear, providing long-term protection for both residential and commercial spaces. Whether you need them for a high-security entrance, patio, or as part of your building's aesthetic appeal, our MS slide doors will meet all your durability requirements and exceed expectations."
  },
  {
    "WhyChooseheading": "Smooth and Effortless Operation",
    "WhyChoosedescription": "Our MS fabrication slide doors are designed for smooth and effortless operation. The sliding mechanism is engineered for minimal friction, making the doors easy to open and close with little physical effort. Even in harsh conditions, the precision engineering ensures the door glides seamlessly. We use high-quality rollers and tracks, reducing the chances of jamming, and ensuring consistent performance for years to come. This smooth operation improves user convenience and enhances the overall experience of interacting with the door."
  },
  {
    "WhyChooseheading": "Customizable Designs",
    "WhyChoosedescription": "We offer a wide range of customizable designs for MS fabrication slide doors, catering to different tastes, styles, and functionality needs. Whether you're looking for a sleek, minimalist design to complement a modern property or a more intricate, decorative style for a traditional setting, we can create a design tailored to your specifications. Our expert craftsmen work closely with clients to deliver bespoke solutions, ensuring that your door seamlessly integrates with your property’s aesthetic while also fulfilling practical security and space-saving requirements."
  },
  {
    "WhyChooseheading": "Space-Saving Solution",
    "WhyChoosedescription": "MS fabrication slide doors are an excellent choice for properties with limited space. Unlike traditional hinged doors that require extra space to swing open, our sliding doors operate horizontally along a track, helping to maximize your available space. This makes them ideal for smaller rooms, apartments, or properties with narrow hallways. By saving space, the MS slide door design improves the overall flow of your space, making it more efficient and functional without sacrificing style or security."
  },
  {
    "WhyChooseheading": "Enhanced Security",
    "WhyChoosedescription": "MS fabrication slide doors are built with security as a priority. We use high-quality, strong materials that form an impenetrable barrier, protecting your home or business from intruders. Our doors come with advanced locking mechanisms that are designed to offer extra protection. In addition, our fabrication process includes reinforced frames and security-enhancing features such as multi-point locking systems. You can rest assured knowing your property is safe and secure with a door that is difficult to breach, even by the most determined intruders."
  },
  {
    "WhyChooseheading": "Weather-Resistant",
    "WhyChoosedescription": "Our MS fabrication slide doors are treated with advanced anti-corrosive coatings to ensure they withstand various weather conditions. Whether it’s extreme heat, heavy rainfall, or humidity, our doors remain in top condition, resisting rust and corrosion. This makes them highly durable and perfect for outdoor use, such as for patios, balconies, or commercial properties exposed to changing weather. The weather-resistant coating not only preserves the door's integrity but also ensures it maintains a clean and polished appearance, offering protection and longevity."
  },
  {
    "WhyChooseheading": "Affordable and High-Quality",
    "WhyChoosedescription": "We provide high-quality MS fabrication slide doors at competitive prices, offering excellent value for money. By sourcing premium-grade mild steel and applying meticulous craftsmanship, we ensure that every door we produce delivers superior strength, security, and functionality. Despite their high quality, our doors are cost-effective, making them an accessible solution for homeowners and business owners alike. You get durable, reliable doors that stand the test of time without breaking the bank, ensuring both affordability and long-term investment."
  },
  {
    "WhyChooseheading": "Professional Installation",
    "WhyChoosedescription": "Our expert team handles the entire installation process with precision and care. We ensure that your MS fabrication slide door is installed securely, ensuring optimal performance. The installation team is well-trained and equipped with the right tools, guaranteeing a flawless setup. We follow all industry best practices, making sure that the doors are fitted perfectly and function as intended. Additionally, we offer after-installation services, ensuring that everything runs smoothly from start to finish and that your door operates without issues in the long run."
  },
  {
    "WhyChooseheading": "Low Maintenance",
    "WhyChoosedescription": "MS fabrication slide doors are designed to be low-maintenance, offering you ease of use for years to come. With a simple cleaning schedule and occasional lubrication of the sliding mechanism, your door will continue to operate smoothly without requiring extensive upkeep. The weather-resistant treatment and durable materials mean that the door will maintain its appearance and functionality, reducing the need for repairs or replacements. We also offer professional maintenance services to keep your doors in prime condition, giving you peace of mind and protecting your investment."
  }
]


  }

  const faqData = [
    {
      question: "What is an MS fabrication slide door?",
      answer: "An MS (Mild Steel) fabrication slide door is a door made from mild steel that operates by sliding horizontally along a track. These doors are designed to provide space-saving solutions and security while offering smooth operation."
    },
    {
      question: "Can MS fabrication slide doors be customized?",
      answer: "Yes, our MS fabrication slide doors are fully customizable. You can choose the design, size, and finish that best suits your property’s style and functional needs."
    },
    {
      question: "Are MS fabrication slide doors secure?",
      answer: "Yes, MS fabrication slide doors are highly secure. They are made from durable mild steel and can be equipped with advanced locking mechanisms to ensure safety and protection for your property."
    },
    {
      question: "How long will MS fabrication slide doors last?",
      answer: "MS fabrication slide doors are built to last for many years. The quality materials and robust construction ensure long-term performance and durability with minimal maintenance required."
    },
    {
      question: "Are MS fabrication slide doors suitable for both residential and commercial use?",
      answer: "Yes, MS fabrication slide doors are suitable for both residential and commercial applications. Whether for a home, office, or retail space, these doors offer a practical and stylish solution."
    },
    {
      question: "How do I maintain my MS fabrication slide door?",
      answer: "MS fabrication slide doors require minimal maintenance. Regular cleaning of the door surface and periodic lubrication of the sliding track will keep the door functioning smoothly. We also offer maintenance services to ensure the door’s longevity."
    },
    {
      question: "How much do MS fabrication slide doors cost?",
      answer: "The cost of MS fabrication slide doors depends on factors such as size, design, and custom features. Contact us for a free consultation and customized quote based on your specific needs."
    },
    {
      question: "Can MS fabrication slide doors be installed in small spaces?",
      answer: "Yes, MS fabrication slide doors are perfect for areas with limited space. Since they slide horizontally, they don’t require additional swing space, making them an ideal choice for compact areas like apartments, balconies, or smaller commercial spaces."
    },
    {
      question: "Can the slide door be designed to match the existing decor?",
      answer: "Absolutely! We offer various design options and finishes to ensure your MS fabrication slide door complements your existing decor, whether it's modern, traditional, or custom-designed."
    },
    {
      question: "Why should I choose Anjali Enterprises for MS fabrication slide door installation?",
      answer: "Anjali Enterprises is known for delivering high-quality MS fabrication slide doors with professional installation services. We offer customizable solutions, superior durability, smooth operation, and affordable pricing, ensuring a great value for your investment."
    }
  ];
  
  const testimonials = [
    {
      name: "Mr. Rajesh Nair",
      text: "I had an MS fabrication slide door installed in my office, and it's been fantastic. The door is secure, operates smoothly, and saves space. The team at Anjali Enterprises was professional and delivered the door on time. Highly recommended!"
    },
    {
      name: "Mrs. Meera Patel",
      text: "The MS fabrication slide doors installed at my home have completely transformed my living space. They not only provide excellent security but also add a touch of elegance. Great service from Anjali Enterprises!"
    }
  ];
  

  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>



<Helmet>
  <title> MS Fabrication Slide Door Installation Services in Pune</title>
  <meta name="description" content="Anjali Enterprises offers MS fabrication slide door installation services in Pune, providing custom steel sliding doors, industrial sliding doors, and modern sliding doors for both residential and commercial use. Call +91 8793220265 for durable sliding door solutions." />
  <meta name="keywords" content="MS Fabrication Slide Door Installation, Steel Sliding Doors, MS Sliding Doors for Offices, Modern Sliding Doors Pune, Industrial Steel Sliding Doors, MS Door Fabricators, Sliding Door Work for Residential and Commercial Use, Custom MS Sliding Door, Durable Sliding Doors for High-Traffic Areas, Steel Sliding Door Solutions" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | MS Fabrication Slide Door Installation Services in Pune" />
  <meta property="og:description" content="Anjali Enterprises offers MS fabrication slide door installation services in Pune, providing custom steel sliding doors, industrial sliding doors, and modern sliding doors for both residential and commercial use. Call +91 8793220265 for durable sliding door solutions." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/ms-fabrication-slide-door-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/ms-fabrication-slide-door-installation" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises offers MS fabrication slide door installation services in Pune, providing custom steel sliding doors, industrial sliding doors, and modern sliding doors for both residential and commercial use. Call +91 8793220265 for durable sliding door solutions.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/ms-fabrication-slide-door-installation",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/ms-fabrication-slide-door-service.jpg",
        "priceRange": "₹7000 - ₹25000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/ms-fabrication-slide-door-installation",
          "priceCurrency": "INR",
          "price": "7000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "reviewCount": "25"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajesh K"
            },
            "datePublished": "2024-07-20",
            "reviewBody": "The sliding doors installed by Anjali Enterprises are of excellent quality and very durable. We use them for high-traffic areas, and they have been working perfectly. Highly recommend their services!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Nikita P"
            },
            "datePublished": "2024-10-10",
            "reviewBody": "We had MS sliding doors installed at our office and residential space. The team did a fantastic job with the installation, and the doors are smooth and reliable. Excellent work!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/ms-fabrication-slide-door-installation"
        },
        "keywords": "MS Fabrication Slide Door Installation, Steel Sliding Doors, MS Sliding Doors for Offices, Modern Sliding Doors Pune, Industrial Steel Sliding Doors, MS Door Fabricators, Sliding Door Work for Residential and Commercial Use, Custom MS Sliding Door, Durable Sliding Doors for High-Traffic Areas, Steel Sliding Door Solutions"
      }
    `}
  </script>
</Helmet>


      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/13.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default MSfabricationslide;